import { motion } from "framer-motion";
import Checkbox from "../form/Checkbox";
import mp3Icon from "../../assets/images/MediaIcon/mp3.png";
import pdfIcon from "../../assets/images/MediaIcon/pdf.png";
import wordIcon from "../../assets/images/MediaIcon/word.png";
import excelIcon from "../../assets/images/MediaIcon/excel.png";
import defaultIcon from "../../assets/images/MediaIcon/file.png";
import pptIcon from "../../assets/images/MediaIcon/powerpoint.png";
import csvIcon from "../../assets/images/MediaIcon/csv.png";
import ActionMenu from "./ActionMenu";

const MediaCard = ({
  file,
  isSelected = () => false,
  toggleSelectedItem = () => {},
  onFolderClick = () => {},
  onFileClick = () => {},
  selectMedia = false,
  editFolderPannel = () => {},
}) => {
  const renderMedia = () => {
    if (file?.mediaType === "image" && file.url) {
      return (
        <img
          src={file?.url}
          alt={file?.name}
          className="w-full h-full object-cover"
        />
      );
    } else if (file?.mediaType === "video" && file.url) {
      return (
        <video
          src={file?.url}
          className="w-full h-full object-cover"
          muted
          autoPlay
          loop
        />
      );
    } else if (file?.mediaType === "folder") {
      return <i className="fa-solid fa-folder text-yellow-500 text-6xl"></i>;
    }

    const iconMap = {
      audio: mp3Icon,
      pdf: pdfIcon,
      word: wordIcon,
      excel: excelIcon,
      ppt: pptIcon,
      csv: csvIcon,
    };

    return (
      <img
        src={iconMap[file?.mediaType] || defaultIcon}
        alt={file?.mediaType}
        className="w-20 h-20 object-contain"
      />
    );
  };

  const handleCardClick = () => {
    if (selectMedia) {
      if (file?.mediaType === "folder" && selectMedia) {
        onFolderClick(file);
      }
    } else {
      if (file?.mediaType === "folder") {
        onFolderClick(file);
      } else if (file?.mediaType === "image") {
        onFileClick(file);
      }
    }
  };

  const actiondata = [
    {
      _id: 2,
      name: "Edit",
      icon: "fa-regular fa-pen-to-square",
      onClick: () => {
        editFolderPannel({ isOpen: true, data: file });
      },
      standout: false,
    },
    {
      _id: 3,
      name: "Delete",
      icon: "fa-regular fa-trash-can",
      standout: true,
      // onClick: () => {
      // },
    },
  ];

  return (
    <motion.div
      whileHover={{
        scale: 1.05,
        boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.1)",
      }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      className={`bg-white p-3 w-full rounded-xl border-2  mx-auto flex flex-col justify-between hover:border-sky-600 cursor-pointer ${
        isSelected(file) ? " border-primary" : " border-gray-200"
      }`}
      onClick={handleCardClick}
    >
      <div className="flex items-start justify-between">
        {(!selectMedia || (selectMedia && file?.mediaType !== "folder")) && (
          <div onClick={(e) => e.stopPropagation()}>
            <Checkbox
              checked={isSelected(file)}
              onChange={() => toggleSelectedItem(file)}
              checkboxLabel=""
              checkboxLableClass="text-base"
            />
          </div>
        )}

        {!selectMedia && (
          <div onClick={(e) => e.stopPropagation()}>
            <ActionMenu data={actiondata} xPlacement={"bottom"} />
          </div>
        )}
      </div>

      <div className="flex flex-col items-center mt-2 space-y-4">
        <div className="h-16 aspect-square flex overflow-hidden rounded">
          {renderMedia()}
        </div>
        <div className="text-center px-2">
          <p
            className="font-semibold text-primary text-sm truncate max-w-[150px] mx-auto"
            title={file?.name || ""}
          >
            {file?.name || ""}
          </p>

          <div className="flex justify-center items-center gap-4 mt-1">
            {file?.mediaType === "folder" && file?.totalFiles > 0 && (
              <p className="text-xs text-gray-700">{file?.totalFiles} Files</p>
            )}
            {file?.mediaType === "folder" && file?.totalFolders > 0 && (
              <p className="text-xs text-gray-700">
                {file?.totalFolders} Folders
              </p>
            )}
          </div>
          {file?.mediaType === "folder" && file?.humanReadableSize ? (
            <p className="text-xs text-gray-500 mt-1">
              {file.humanReadableSize}
            </p>
          ) : file?.mediaType !== "folder" && file?.fileSizeReadable ? (
            <p className="text-xs text-gray-500 mt-1">
              {file.fileSizeReadable}
            </p>
          ) : null}
        </div>
      </div>
    </motion.div>
  );
};

export default MediaCard;
